import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../items/style/animationstyle';
import './machine_css.css';
import MachineCategoryCard from './machineCategoryCard';
import ToggleLanguage from '../items/buttons/ToggleLanguage';
import { useTranslation } from 'react-i18next';
import 'react-simple-keyboard/build/css/index.css';
import { ReactComponent as BackIcon } from '../Icons/Back_icon.svg';
import { ReactComponent as CartIcon } from '../Icons/Cart_icon.svg';
import { ReactComponent as HomeIcon } from '../Icons/Home_icon.svg';
import { ReactComponent as SearchIcon } from '../Icons/magnifier.svg';
import { Link } from 'react-router-dom';
import Search from './items/Search';
import logger from '../services/LocalServer/logger';
import { ExitToApp } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import BottomCart from './ShoppingCart/BottomCart';

function Brands(props) {
  let history = useHistory();
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const {
    langs,
    stat,
    setStat,
    add,
    decreStock,
    alterquantity,
    remove,
    setShowCart,
    showCart,
    cart,
  } = props;
  const { t } = useTranslation();
  const machineID = props.id;

  const [brands, setBrands] = useState([]);
  const [input, setInput] = useState('');
  const [column, setColumn] = useState('1');
  const [languages, setLanguage] = useState([]);
  const [show, setShow] = useState(false);

  let machine = JSON.parse(localStorage.getItem('machine'));
  let logoutIcon = localStorage.getItem('LOGOUT') === 'TRUE';
  const showName = machine?.themeColor?.brand_image_button === 'true' ? true : false;

  const cColumn = () => {
    let c = machine;
    let result = '1';
    if (c.themeColor && c.themeColor.c_column) {
      result = c.themeColor.c_column;
    }
    console.log('c', result);
    return result;
  };

  const c_Column = cColumn();

  const bColumn = () => {
    let c = machine;
    let result = '1';
    if (c.themeColor && c.themeColor.b_column) {
      result = c.themeColor.b_column;
    }
    console.log('b', result);
    return result;
  };

  useEffect(() => {
    setColumn(bColumn());
    setBrands(
      JSON.parse(localStorage.getItem('brand')) ? JSON.parse(localStorage.getItem('brand')) : []
    );
    setLanguage(
      JSON.parse(localStorage.getItem('machine'))
        ? JSON.parse(localStorage.getItem('machine')).languages
        : null
    );
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    logger(2, 'Machine on brands page.');
  }, []);

  useEffect(() => {
    if (stat.all_brand) stat.all_brand = stat.all_brand += 1;
    else stat.all_brand = 1;
    setStat(stat);
  }, []);

  let result;

  if (input.length > 0) {
    result = brands.filter((category) =>
      category.name[langs]?.toLowerCase().includes(input.toLowerCase())
    );
  } else {
    result = [...brands];
  }

  //sort by name
  result = result?.sort((a, b) => {
    const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
    const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  const allCat = {
    key: 1,
    id: 1,
    name: {
      en: 'All Products',
      fr: 'Tous les produits',
      es: 'Todos los productos',
    },
    image:
      'https://jvmsaas.com/media/blog/cache/840x620/magefan_blog/Fashion-Shoes-Jewelry-2X._V510055193_3.jpg',
    machineID: machineID,
  };

  const category = {
    key: 2,
    id: 2,
    name: {
      en: 'Categories',
      fr: 'catégories',
      es: 'categorías',
    },
    image:
      'https://jvmsaas.com/media/blog/cache/840x620/magefan_blog/Fashion-Shoes-Jewelry-2X._V510055193_3.jpg',
    machineID: machineID,
  };

  if (machine?.themeColor?.allProduct) {
    if (isLocal) {
      allCat.image = `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor.allProduct}`;
      category.image = `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor.allProduct}`;
    } else {
      allCat.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allProduct}/${machine.belongTo}`;
      category.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allProduct}/${machine.belongTo}`;
    }
  }

  if (machine?.themeColor?.allCate) {
    category.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allCate}/${machine.belongTo}`;
  }

  const categories = result.map((brand) => {
    console.log('machine?.themeColor?.brand_image_button', machine?.themeColor?.brand_image_button);
    const Banme =
      brand.name[langs] && brand.name[langs] !== '' ? brand.name[langs] : brand.name?.en;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${brand.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${brand.picture}/${brand.referTo}`;
    return (
      <div
        key={brand._id}
        className="row justify-content-center mb-4"
        onClick={() => {
          localStorage.setItem('currentCate', JSON.stringify(brand));
        }}
      >
        <MachineCategoryCard
          column={column}
          brandOrCate="brand"
          id={brand._id}
          machineID={machineID}
          showName={showName}
          catename={Banme}
          cateEn={brand.name.en}
          image={url}
        />
      </div>
    );
  });

  if (c_Column !== '0') {
    categories.unshift(
      <div key={2} className="row justify-content-center mb-4">
        <MachineCategoryCard
          column={column}
          showName={showName}
          id={2}
          machineID={category.machineID}
          catename={category.name[langs]}
          cateEn={category.name.en}
          image={category.image}
        />
      </div>
    );
  }

  categories.unshift(
    <div key={1} className="row justify-content-center mb-4">
      <MachineCategoryCard
        column={column}
        brandOrCate="all"
        id={1}
        showName={showName}
        machineID={allCat.machineID}
        catename={allCat.name[langs]}
        cateEn={allCat.name.en}
        image={allCat.image}
      />
    </div>
  );

  return (
    <div className="ui-secondary-div">
      <motion.div
        key="category-div"
        className="container"
        initial="initial"
        exit="out"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}
      >
        <img className="category-logo" alt="Logo" />
        <div className="row align-items-center justify-content-center">
          <div>
            {languages != null && (
              <ToggleLanguage
                setlangs={props.setlangs}
                langs={props.langs}
                p="p"
                l={languages}
                machineID={machineID}
              />
            )}
          </div>
          <div style={{ marginLeft: '50px' }}>
            <Search show={show} setShow={setShow} input={input} setInput={setInput} />
          </div>
        </div>
        <div className="row justify-content-center mt-5 mb-5">
          <span className="cat-title">
            {result.length == 0 ? (
              <h2>{t(`No matching categories is found`)}!</h2>
            ) : (
              t('Brands').toUpperCase()
            )}
          </span>
        </div>
        <div
          className="items-container"
          style={{ display: 'grid', gridTemplateColumns: `repeat(${column}, 1fr)` }}
        >
          {categories}
        </div>
      </motion.div>
      <div className="bottom-buttons-div">
        <span>
          <HomeIcon className="svg-style mr-3" />
        </span>
        <CartIcon
          className="svg-style myCartIcon"
          onClick={() => {
            if (localStorage.getItem('cartStyle') === 'true') {
              setShowCart(true);
            } else {
              history.push(`/machineUI/${props.machineID}/checkout`);
            }
          }}
        />
        <span className="item-counter-p">
          <span className="myCartCounter">{props.itemCounter}</span>
        </span>

        <BackIcon id="mybackIcon" className="svg-style ml-3 backIcon" />
        <span
          onClick={() => {
            setShow(true);
            setInput('');
          }}
        >
          <SearchIcon className="svg-style mr-3" />
        </span>
        {logoutIcon && (
          <Link to={`/machineUI/slider/${machineID}`}>
            <ExitToApp className="svg-style myCartIcon" />
          </Link>
        )}
      </div>
      <BottomCart
        isLocal={isLocal}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
      />
    </div>
  );
}
export default Brands;
